export const UPDATE_SHIFT_PRIORITY_SETTINGS_BEGIN = 'UPDATE_SHIFT_PRIORITY_SETTINGS_BEGIN'
export const UPDATE_SHIFT_PRIORITY_SETTINGS_SUCCESS = 'UPDATE_SHIFT_PRIORITY_SETTINGS_SUCCESS'
export const UPDATE_SHIFT_PRIORITY_SETTINGS_ERROR = 'UPDATE_SHIFT_PRIORITY_SETTINGS_ERROR'